import { FC } from 'react';
import { Divider, Text } from '@kl/components-v6';
import { ChangeLanguage, ChangeLanguageButton } from 'shared/ui/change-language';
import { StyledLandingContainer } from 'shared/ui/styled-components';
import { LocaleWithLink } from 'shared/ui/no-concat-locale';
import { Locale } from 'shared/ui/locale';
import {
    Dot,
    StyledChangeLanguageContainer,
    StyledFirstLineWrapper,
    StyledFooterFeaturedPagesLinks,
    StyledFooterWrapper,
    StyledLocaleWithLink,
} from './styled';

export const Footer: FC<{ isKscMode: boolean }> = ({ isKscMode }) => {
    return (
        <StyledLandingContainer
            $align="center"
            $justify="center"
            $padding="16px 0 24px"
            $width="100%"
        >
            <StyledFooterWrapper data-testid="footer">
                <StyledFirstLineWrapper>
                    <Text color="secondary" type="BTR4">
                        <span>
                            <Locale
                                localizationKey="Landing.Unauthenticated_Copyright"
                                params={[new Date().getFullYear()]}
                            />
                        </span>
                        <Dot />
                        <StyledLocaleWithLink
                            color="#1DA189"
                            localizationKey="PrivacyPolicy.Caption"
                            attributes={{
                                'privacy-policy-link': {
                                    target: '_blank',
                                    'data-testid': 'privacyPolicyLink',
                                },
                            }}
                        />
                        <Dot />
                        <LocaleWithLink
                            color="#1DA189"
                            localizationKey="LegalNotice.Caption"
                            attributes={{
                                'legal-notice-link': {
                                    target: '_blank',
                                    'data-testid': 'legalNoticeLink',
                                },
                            }}
                        />
                    </Text>
                    <StyledChangeLanguageContainer>
                        <ChangeLanguage trigger="click">
                            <ChangeLanguageButton />
                        </ChangeLanguage>
                    </StyledChangeLanguageContainer>
                </StyledFirstLineWrapper>
                <Divider />
                <StyledFooterFeaturedPagesLinks color="secondary" type="BTR4">
                    <LocaleWithLink
                        color="#999999"
                        localizationKey={
                            isKscMode ? 'OnlineHelp.CaptionKscCC' : 'OnlineHelp.CaptionNext'
                        }
                        attributes={{
                            'help-link': {
                                target: '_blank',
                                'data-testid': 'helpLink',
                            },
                        }}
                    />
                    <Dot />
                    <LocaleWithLink
                        color="#999999"
                        localizationKey="ContactUs.Caption"
                        attributes={{
                            'contact-link': {
                                target: '_blank',
                                'data-testid': 'contactLink',
                            },
                        }}
                    />
                </StyledFooterFeaturedPagesLinks>
            </StyledFooterWrapper>
        </StyledLandingContainer>
    );
};
